
function ProjectInProgressState({ status, feedback }) {
  if (status === 'COMPLETED') {
    return (
      <div className="project-state project-in-progress-state">
        <img src="/images/profile/aproved-icon.png" width="24" height="24" alt="Icono del estado del proyecto" />
        <span>Aprobado</span>
      </div>
    )
  }

  if (status === 'IN PROGRESS' && feedback) {
    return (
      <div className="project-state project-in-progress-state">
        <img src="/images/profile/in-progress-icon.png" width="24" height="24" alt="Icono del estado del proyecto" />
        <span>Con feedback</span>
      </div>
    )
  }

  if (status === 'IN REVIEW') {
    return (
      <div className="project-state project-in-progress-state">
        <img src="/images/profile/in-review-icon.png" width="24" height="24" alt="Icono del estado del proyecto" />
        <span>En revisión</span>
      </div>
    )
  }

  return (
    <div className="project-state project-in-progress-state">
      <img src="/images/profile/in-progress-icon.png" width="24" height="24" alt="Icono del estado del proyecto" />
      <span>Solicitar revisíon</span>
    </div>
  )
}

export default ProjectInProgressState
